import { createFromIconfontCN } from "@ant-design/icons"

//定义项目中使用的图标
const YcIcon = createFromIconfontCN({
    scriptUrl: "//at.alicdn.com/t/font_1893936_c4mx3eku92i.js",
})

export default YcIcon
